import React from 'react';

import {FmlxButton} from 'fmlx-common-ui';
import {uniqueId} from 'lodash';
import PropTypes from 'prop-types';

import {gapFixerClass} from '@/libs/styleHelper';

import style from './ModalCommon.module.scss';

function ModalCommonButtons({data}) {
  return (
    <div className={`${style.buttons} ${gapFixerClass()}`}>
      {data.map((button, i) => {
        let type = FmlxButton.Type.PRIMARY;
        let variant = FmlxButton.Variant.CONTAIN;

        switch (i) {
          case 0:
            type = button.type || FmlxButton.Type.PRIMARY;
            variant = button.variant || FmlxButton.Variant.CONTAIN;
            break;
          case 1:
            type = button.type || FmlxButton.Type.BASIC;
            variant = button.variant || FmlxButton.Variant.OUTLINE;
            break;
          case 2:
          default:
            type = button.type || FmlxButton.Type.BASIC;
            variant = button.variant || FmlxButton.Variant.PLAIN;
            break;
        }

        const buttons = !button.hide ? (
          <FmlxButton
            key={button.id || uniqueId()}
            id={button.id || uniqueId()}
            onClick={button.onClick}
            label={button.label}
            disabled={button.disabled}
            type={type}
            variant={variant}
          />
        ) : null;

        return buttons;
      })}
    </div>
  );
}

export default ModalCommonButtons;

ModalCommonButtons.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      hide: PropTypes.bool,
      disabled: PropTypes.bool,
      label: PropTypes.string.isRequired,
      type: PropTypes.oneOf(Object.values(FmlxButton.Type)),
      variant: PropTypes.oneOf(Object.values(FmlxButton.Variant)),
      onClick: PropTypes.func.isRequired,
    }),
  ),
};

ModalCommonButtons.defaultProps = {
  data: [],
};
